import { send } from 'server';

export const getExternalBalance = () => send({
    ID: 35823,
    responses: [35824, 35825],
    description: 'Get External Fund Transfer Balance'
});

export const deposit = ({ currencyCode, amount, pin }) => send({
    ID: 35826,
    responses: [35827, 35828],
    description: 'External Fund Transfer Deposit',
    errorLevel: 1,
    amount: {
        amount,
        currencyCode
    },
    parameters: [{
        key: 'pinNumber',
        value: pin
    }]
});

export const withdraw = ({ currencyCode, amount, pin }) => send({
    ID: 35829,
    responses: [35830, 35831],
    description: 'External Fund Transfer Withdraw',
    errorLevel: 1,
    amount: {
        amount,
        currencyCode
    },
    parameters: [{
        key: 'pinNumber',
        value: pin
    }]
});

export const getInternalBalance = ({ balanceTypes }) => send({
    ID: 31020,
    responses: [35824, 35825],
    description: 'Get Dynamic Balance',
    balanceTypes
});
